<template>
  <product-about-card v-if="branch?.intro" class="product-desc" :title="$t('branch_detail.about.description')">
    <div ref="descRef" class="line-clamp-3 whitespace-pre-wrap" v-html="branch.intro" />

    <content-viewer
      v-if="isClamped"
      :title="$t('branch_detail.about.description')"
      :is-full-height="true"
      :is-footer-shown="false"
      :is-fallback-shown="true"
      main-content-class="pt-5 pb-10"
    >
      <template #trigger="{ open }">
        <product-view-all-button @view-all-click="open" />
      </template>
      <div class="whitespace-pre-wrap" v-html="branch.intro" />
    </content-viewer>
  </product-about-card>
</template>

<script lang="ts" setup>
import ContentViewer from '@/components/common/content-viewer.vue'
import ProductViewAllButton from '@/components/product/product-detail/product-view-all-button.vue'
import ProductAboutCard from '@/components/product/product-detail/product-about-card.vue'

const { branch } = useBranchDetailContext()

const isClamped = ref(false)
const descRef = ref<Nullable<HTMLElement>>(null)

onMounted(() => {
  if (!descRef.value) {
    return
  }

  isClamped.value = descRef.value.scrollHeight > descRef.value.clientHeight
})
</script>
